module.exports = __webpack_public_path__ + "static/media/1027701.39e75cdb.png";